<!-- BSG-compliant language selector popover -->
<div class="wrapper bsg-language-popover" role="dialog" aria-labelledby="language-selection-title">
	<!-- Hidden title for screen readers -->
	<h2 id="language-selection-title" class="bsg-visually-hidden">Select Language</h2>

	<!-- Language options list -->
	<ul role="radiogroup" aria-label="Available languages">
		<li *ngFor="let lang of listCountries; let i = index">
			<button
				class="bsg-language-option"
				(click)="dismissWithData(lang.value)"
				[attr.aria-selected]="lang.value === selectedLanguage"
				role="radio"
				tabindex="0"
			>
				<div class="wrapper">
					<div class="info_block">
						<ion-img [src]="lang.icon" [alt]="lang.name + ' flag'" aria-hidden="true"></ion-img>
						<p>{{ lang.name }}</p>
					</div>

					<div class="circle" aria-hidden="true">
						<div class="cirle_inner" [class.selected]="lang.value === selectedLanguage"></div>
					</div>
				</div>
			</button>
		</li>
	</ul>
</div>
